import { combineReducers } from '@reduxjs/toolkit';
import rewardDashboardSlice from './reward.slice';
import rewardRecordingsSlice from './recording.slice';
import rewardSingleRecordingslice from './single-recording.slice';
import rewardsPurchasedSlice from './purchased.slice';
import rewardsSubjectSlice from './subject.slice';

export const rewardRootReducer = combineReducers({
    dashboard: rewardDashboardSlice,
    recording: rewardRecordingsSlice,
    single_recording: rewardSingleRecordingslice,
    purchased: rewardsPurchasedSlice,
    subject: rewardsSubjectSlice,
});
